import KendoGanttDataSourceMixin from './KendoGanttDataSourceMixin'

export default {
    name: 'kendo-ganttdatasource',
    mixins: [ KendoGanttDataSourceMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDataSource/index.js